import { handleLocalStorage } from 'shared/helpers/handleLocalStorage'
import { create } from 'zustand'
import { IS_CC_SELECTED } from './types'

const getInitialQrStore = () => {
  const isCCLS = handleLocalStorage(IS_CC_SELECTED)
  return {
    qrCodeValue: `${
      isCCLS ? process.env.REACT_APP_CLICKCOLLECT_URL : process.env.REACT_APP_QRMENU_URL
    }`,
    selectedCaption: ''
  }
}

export const useQrCodeStore = create<IQrCodeStore>(set => ({
  ...getInitialQrStore(),
  changeQrCodeValue: (newQrValue, newCaption) => {
    set(state => {
      return {
        ...state,
        qrCodeValue: newQrValue,
        selectedCaption: newCaption || state.selectedCaption
      }
    })
  },
  discardQrCodeValue: () => {
    set(state => {
      const isCCLS = handleLocalStorage(IS_CC_SELECTED)
      return {
        ...state,
        qrCodeValue: `${
          isCCLS ? process.env.REACT_APP_CLICKCOLLECT_URL : process.env.REACT_APP_QRMENU_URL
        }`,
        selectedCaption: ''
      }
    })
  }
}))

export interface IQrCodeStore {
  qrCodeValue: string
  selectedCaption: string
  changeQrCodeValue: (qrValue: string, caption?: string) => void
  discardQrCodeValue: () => void
}
